import ResponsiveBootstrapToolkit from 'responsive-toolkit';

ResponsiveBootstrapToolkit.breakpoints = {
    'xs':  $('<div class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none"></div>'),
    'sm':  $('<div class="d-none d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"></div>'),
    'md':  $('<div class="d-none d-sm-none d-md-block d-lg-none d-xl-none d-xxl-none"></div>'),
    'lg':  $('<div class="d-none d-sm-none d-md-none d-lg-block d-xl-none d-xxl-none"></div>'),
    'xl':  $('<div class="d-none d-sm-none d-md-none d-lg-none d-xl-block d-xxl-none"></div>'),
    'xxl': $('<div class="d-none d-sm-none d-md-none d-lg-none d-xl-none d-xxl-block"></div>'),
};

const responsive = ResponsiveBootstrapToolkit;

export default responsive;
